/**
 * Canvas Line
 */

import CanvasParent from "./CanvasParent";
import canvTools from "./canvas-tools";
export default class CanvasLine extends CanvasParent {

  type = 'polygon';

  constructor(width, height, id) {
    super(width, height, id);
    document.addEventListener('click', this._extendLine)
  }

  draw = () => {
    canvTools.drawMultipleLine(this);
  }

  _extendLine = (event) => {
    if (this.clicked === false) {
      this.clicked = true;
      document.addEventListener('mousemove', this._listenDrawLine);
      document.addEventListener('keydown', this._undo);
      this.currentLine.start = [event.pageX - this.offsetLeft, event.pageY - this.offsetTop];
      this._newStartPoint(this);
    } else {
      this.positions.push(JSON.parse(JSON.stringify(this.currentLine)));
      this.currentLine.start = this.currentLine.end;
    }
  }
  

  _listenDrawLine = (event) => {
    if (!this.clicked) return;
    let xMin = this.offsetLeft;
    let xMax = this.offsetLeft + this.width;
    let yMin = this.offsetTop;
    let yMax = this.offsetTop + this.height;
    let endX, endY;
    if (event.pageX > xMax) endX = xMax - this.offsetLeft;
    else if (event.pageX < xMin) endX = xMin - this.offsetLeft;
    else endX = event.pageX - this.offsetLeft;

    if (event.pageY > yMax) endY = yMax - this.offsetTop;
    else if (event.pageY < yMin) endY = yMin - this.offsetTop;
    else endY = event.pageY - this.offsetTop;

    this.currentLine.end = [endX, endY];
    canvTools.drawMultipleLine(this, true);
  }

  _endListen = () => {
    if (this.positions.length < 2) return;
    this.currentLine.end = this.positions[0].start;
    this.positions.push(JSON.parse(JSON.stringify(this.currentLine)));
    canvTools.drawMultipleLine(this, true);
    setTimeout(() => this.valided = true, 100);
    this.clicked = false;
    document.removeEventListener('click', this._extendLine);
    document.removeEventListener('keydown', this._undo);
    document.removeEventListener('mousemove', this._listenDrawLine);
    this.stopListenMouse();
    this.startPoint.parentElement.removeChild(this.startPoint);
  }

  _undo = (event) => {
    if (this.positions.length === 0) return;
    let ctrl = event.ctrlKey || event.metaKey;
    let key = event.key;
    if (ctrl === true && key === 'z') {
      let lastPos = this.positions.pop();
      this.currentLine = {start: lastPos.start, end: this.currentLine.end}
      canvTools.drawMultipleLine(this, true);
    }
  }

  _newStartPoint = (canvasObj) => {
    let div = document.createElement('div');
    div.classList.add('start-point');
    div.id = 'start-point-' + this.id;
    div.style.left = event.pageX - canvasObj.offsetLeft + 'px';
    div.style.top = event.pageY - canvasObj.offsetTop + 'px';
    div.addEventListener('click', canvasObj._endListen);
    canvasObj.startPoint = div;
    document.getElementById('canvas-content').appendChild(div);
  }
}